var _a;
import { ObjectBuilder, ImgButtonWithText, LayoutUtils } from "@dreamcam/babylon-tools";
import { BroadcastApiStatus } from "@dreamcam/web-sdk";
import { text } from "../../TextResources";
import { Env } from "../../settings/Env";
import { Rectangle } from "@babylonjs/gui/2D/controls/rectangle.js";
import { LayoutComponentHelper } from "./LayoutComponentHelper";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
export class LobbySelectedModelPanelContainer {
    constructor(mesh2d, callbacks) {
        this._studioModel = null;
        this._broadcast = null;
        this._videosCount = null;
        this._mesh2d = mesh2d;
        this._callbacks = callbacks;
        const sm = Env.lobby.selectedModel;
        const backgroundPanel = new Rectangle("selectedModelBackgroundPanel");
        backgroundPanel.background = sm.backgroundPanel.color;
        backgroundPanel.thickness = 0;
        backgroundPanel.cornerRadius = this._mesh2d.m2px(sm.backgroundPanel.cornerRadius);
        this._mesh2d.texture.addControl(backgroundPanel);
        this._modelProfileControls =
            LayoutComponentHelper.createModelProfileControl(this._mesh2d, backgroundPanel, sm.modelProfileComponent);
        this._modelProfileControls.rootContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._modelProfileControls.rootContainer.topInPixels = this._mesh2d.m2px(sm.modelProfileComponent.top);
        this._modelNicknameTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "selectedModelNickname", "", sm.modelNickname);
        backgroundPanel.addControl(this._modelNicknameTextBlock);
        this._videoClipCountTextBlock = ObjectBuilder.createTextBlock3D(this._mesh2d, "selectedModelVideoClipCount", "", sm.videoClipCount);
        backgroundPanel.addControl(this._videoClipCountTextBlock);
        const btn = sm.openLiveBroadcastButton;
        this._openLiveBroadcastButton = new ImgButtonWithText("openLiveBroadcastButton", {
            imageLayout: LayoutUtils.GetButtonLayout(btn.colorLayout, mesh2d),
            textLayout: mesh2d.textLayoutM2Px(btn.textLayout),
            text: text.lobby_model_info_goto_online_broadcast_button,
        });
        this._openLiveBroadcastButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
        this._openLiveBroadcastButton.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._openLiveBroadcastButton.topInPixels = mesh2d.m2px(btn.top);
        this._openLiveBroadcastButton.widthInPixels = mesh2d.m2px(btn.onlineWidth);
        this._openLiveBroadcastButton.heightInPixels = mesh2d.m2px(btn.height);
        this._openLiveBroadcastButton.onClickObserver.add(async () => {
            const studioModel = this._callbacks.getGalleryModel();
            if (studioModel !== null) {
                await this._callbacks.openBroadcastAsync({ modelNickname: studioModel.modelNickname });
            }
        });
        backgroundPanel.addControl(this._openLiveBroadcastButton);
    }
    drawVideoClips(thumbnails) {
        this._videosCount = thumbnails.totalCount;
        this._videoClipCountTextBlock.text = `${this._videosCount} ${text.lobby_models_videos_label}`;
        this._hideSkeleton();
    }
    updateSelectedModelInfo(studioModel, broadcast) {
        this._studioModel = studioModel;
        this._broadcast = broadcast;
        if (studioModel === null && broadcast === null) {
            this._showSkeleton();
        }
        if (studioModel) {
            this._modelNicknameTextBlock.text = studioModel.modelNickname;
            // this._videoClipCountTextBlock.text = `${studioModel.videoClipCount} ${text.lobby_models_videos_label}`;
        }
        const btn = Env.lobby.selectedModel.openLiveBroadcastButton;
        let statusData;
        if (broadcast) {
            this._modelProfileControls.modelProfileImage.setSource(broadcast.modelProfilePhotoUrl, Env.lobby.gallery.defaultPreview.path);
            statusData = _a._statusMap[broadcast.broadcastStatus];
        }
        else {
            this._modelProfileControls.modelProfileImage.setSource(Env.lobby.gallery.defaultPreview.path);
            statusData = _a._statusMap[BroadcastApiStatus.OFFLINE];
        }
        this._modelProfileControls.statusTextContainer.background = statusData.color;
        this._modelProfileControls.outlineContainer.color = statusData.color;
        this._modelProfileControls.statusText.text = statusData.text;
        const isOffline = broadcast?.broadcastStatus === BroadcastApiStatus.OFFLINE;
        this._openLiveBroadcastButton.text = isOffline
            ? text.lobby_model_info_goto_offline_broadcast_button
            : text.lobby_model_info_goto_online_broadcast_button;
        this._openLiveBroadcastButton.widthInPixels = this._mesh2d.m2px(isOffline ? btn.offlineWidth : btn.onlineWidth);
        this._hideSkeleton();
    }
    _setControlsVisibility(isVisible) {
        this._modelProfileControls.rootContainer.isVisible = isVisible;
        this._modelNicknameTextBlock.isVisible = isVisible;
        this._openLiveBroadcastButton.isVisible = isVisible;
        this._videoClipCountTextBlock.isVisible = isVisible;
    }
    _showSkeleton() {
        this._setControlsVisibility(false);
        this._videosCount = null;
    }
    _hideSkeleton() {
        if ((this._studioModel !== null || this._broadcast !== null) && this._videosCount !== null) {
            this._setControlsVisibility(true);
        }
    }
}
_a = LobbySelectedModelPanelContainer;
LobbySelectedModelPanelContainer._statusImage = Env.broadcast.menu.modelProfile.status;
LobbySelectedModelPanelContainer._statusMap = {
    [BroadcastApiStatus.AWAY]: { color: _a._statusImage.background.away, text: text.lobby_gallery_item_status_away },
    [BroadcastApiStatus.PRIVATE]: { color: _a._statusImage.background.private, text: text.lobby_gallery_item_status_privateShow },
    [BroadcastApiStatus.PUBLIC]: { color: _a._statusImage.background.live, text: text.lobby_gallery_item_status_live },
    [BroadcastApiStatus.OFFLINE]: { color: _a._statusImage.background.offline, text: text.lobby_gallery_item_status_offline },
};
